//import gsap from "gsap";
//import ScrollTrigger from "gsap/ScrollTrigger";
import UIkit from 'uikit';
import Icons from 'uikit/dist/js/uikit-icons';

//gsap.registerPlugin(ScrollTrigger);

UIkit.use(Icons);

window.addEventListener('load', init);
function init() {
    let boxReloadLink = document.querySelector('.consent_manager-show-box-reload');

    if (boxReloadLink) {
        boxReloadLink.addEventListener('click', () => {
            consent_manager_parameters.forcereload = 1;
            consent_manager_showBox();
        })
    }
}

function hideOffcanvas() {
    UIkit.offcanvas('.mobile-navigation').hide();
}

let benefitSlider = UIkit.slider('.text-img-slider');

if (benefitSlider) {
    UIkit.util.on('.text-img-slider', 'itemshow', function () {
        const index = benefitSlider.index;

        // Alle add-* Elemente durchgehen
        document.querySelectorAll('[id^="add-"]').forEach(el => {
            if (el.id === `add-${index}`) {
                el.classList.remove('uk-hidden');
            } else {
                el.classList.add('uk-hidden');
            }
        });
    });
}

/*
const section = document.querySelector(".dynamic-padding");

window.addEventListener("scroll", () => {
    let scrollY = window.scrollY;

    // Begrenzen zwischen 0 und 70
    if (scrollY > 110) scrollY = 110;
    if (scrollY < 0) scrollY = 0;


    section.style.transform = `translateY(${scrollY}px)`;
});

*/


let playBttn = document.querySelectorAll('.process-grid-video-play');

if(playBttn){
    playBttn.forEach(button => {
        // das zugehörige Video im selben Container finden
        const video = button.parentElement.querySelector('video');

        button.addEventListener('click', function () {

            // Video abspielen
            video.play();

            // Button ausblenden
            this.style.display = 'none';
        });
        video.addEventListener('ended', () => {
            button.style.display = 'block';
        });
        video.addEventListener('play', () => {
            button.style.display = 'none';
        });
    });
}

/*
//HERO Banner Scroll Animation
const hero = document.querySelector("#startbanner");
const toggleElements = hero.querySelectorAll("[data-tggl]");




// 1️⃣ Zustand 0 direkt setzen, bevor ScrollTrigger aktiv wird
toggleElements.forEach(el => {
    const origVal = el.getAttribute("data-orig");

    if (el.classList.contains("startbanner-img")) {
        const img = el.querySelector("img");
        if (img) img.src = "/media/" + origVal;   // Bild direkt auf Original setzen
    } else {
        el.innerHTML = origVal;                   // Text direkt auf Original setzen
    }
});

// 2️⃣ Hero nach Laden sichtbar machen
window.addEventListener("load", () => {
    hero.classList.add("loaded");
});

let currentState = 0; // 0 = Zustand 1, 1 = Zustand 2
let animating = false;




function switchState(state) {
    if (state === currentState || animating) return; // Schon animierend oder gleicher State
    currentState = state;
    animating = true;

    toggleElements.forEach(el => {
        const targetVal = state === 1 ? el.getAttribute("data-tggl") : el.getAttribute("data-orig");

        if (el.classList.contains("startbanner-img")) {
            const img = el.querySelector("img");
            if (!img) return;

            gsap.killTweensOf(img);

            gsap.to(img, {
                opacity: 0,
                duration: 0.6,
                ease: "power2.inOut",
                onComplete: () => {
                    img.src = "/media/" + targetVal;
                    gsap.to(img, {
                        opacity: 1,
                        duration: 0.8,
                        ease: "power2.out",
                        delay: 0.2,
                        onComplete: () => animating = false
                    });
                }
            });

        } else {
            gsap.killTweensOf(el);

            gsap.to(el, {
                opacity: 0,
                y: -20,
                duration: 0.6,
                ease: "power2.inOut",
                onComplete: () => {
                    el.innerHTML = targetVal;
                    gsap.to(el, {
                        opacity: 1,
                        y: 0,
                        duration: 0.8,
                        ease: "power2.out",
                        delay: 0.2,
                        onComplete: () => animating = false
                    });
                }
            });
        }
    });
}

ScrollTrigger.create({
    trigger: hero,
    start: "top top",
    end: "+=1800",
    pin: true,
    pinSpacing: true,
    anticipatePin: 1,
    onUpdate: self => {
        // Wechsel einmalig bei scrollen
        const newState = self.progress > 0.5 ? 1 : 0;
        switchState(newState);
    }
});





//Header
const delayedHeader = document.querySelector('.site-header--delayed');
const activateAt = 2000;

if (delayedHeader) {
    window.addEventListener('scroll', () => {
        if (window.scrollY >= activateAt) {
            delayedHeader.classList.add('is-active');
        } else {
            delayedHeader.classList.remove('is-active');
        }
    });
}

*/
// Globaler Listener für alle Menü-Buttons, die das Offcanvas öffnen sollen
document.addEventListener('click', function (e) {
    // Prüfe ob das geklickte Element (oder ein Parent) den Toggle-Trigger hat
    const toggle = e.target.closest('[uk-toggle="target: #offcanvas-usage"]'); // ID deines Offcanvas anpassen!

    if (toggle) {
        e.preventDefault();
        // UIkit Offcanvas manuell ansprechen
        const offcanvasElement = document.getElementById('offcanvas-usage'); // Deine Offcanvas ID
        UIkit.offcanvas(offcanvasElement).show();
    }
});

document.addEventListener('DOMContentLoaded', () => {
    const banner = document.getElementById('startbanner');
    if (!banner) return; // Sicherheitscheck

    const toggleElements = banner.querySelectorAll('[data-tggl]');
    const threshold = 10;
    let isToggled = false;

    const performChange = (state) => {
        // 1. Erstmal alles ausblenden
        banner.classList.add('is-transitioning');
        banner.classList.remove('scrolled-state'); // Animation-Klasse entfernen für Reset

        setTimeout(() => {
            toggleElements.forEach(el => {
                const targetVal = state === 'new' ? el.getAttribute('data-tggl') : el.getAttribute('data-orig');

                if (el.classList.contains('startbanner-img')) {
                    const img = el.querySelector('img');
                    if (img) img.src = img.src.replace(/[^/]+$/, targetVal);
                } else {
                    el.textContent = targetVal;
                }
            });

            // 2. Jetzt die neue Klasse setzen
            if (state === 'new') {
                banner.classList.add('scrolled-state');
            }
            // Wenn state === 'orig', bleibt scrolled-state weg und es fadet normal zurück

            banner.classList.remove('is-transitioning');
        }, 600);
    };



    setTimeout(() =>{
        performChange('new');
    }, 1500);

    // Scroll-Event mit Check
    /* window.addEventListener('scroll', () => {
         const scrollY = window.scrollY;

         if (scrollY >= threshold && !isToggled) {
             isToggled = true;
             performChange('new');
             //banner.querySelector('.hero-inner').classList.add('hero-banner-top');
         } else if (scrollY < threshold && isToggled) {
             isToggled = false;
             performChange('orig');
             //banner.querySelector('.hero-inner').classList.remove('hero-banner-top');
         }
     }, { passive: true }); // Performance-Optimierung für Scroll-Events */
});




console.log('home');





/*

const SLOW_START = 0;
const SLOW_END = 300;
const SLOW_FACTOR = 0.6;   // 60 % → nur leicht langsamer
const MAX_DELTA = 60;      // wichtig für Trackpads

window.addEventListener("wheel", e => {
    const y = window.scrollY;

    // Nur in der Slow-Zone eingreifen
    if (y >= SLOW_START && y <= SLOW_END) {
        e.preventDefault();

        // delta normalisieren (Trackpad-Schutz)
        const raw = e.deltaY;
        const delta = Math.sign(raw) * Math.min(Math.abs(raw), MAX_DELTA);

        window.scrollBy(0, delta * SLOW_FACTOR);
    }
}, { passive: false });

*/



